import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { AppRoutes } from '@/utils/types';
import { useNavigate } from 'react-router-dom';

export const useCreatePremiumPlusAvatarRedirect = () => {
    const { isAnonymous, loginWithRedirect } = useAuth();
    const mixpanel = useAnalytics();
    const navigate = useNavigate();

    const onClick = ({ from, fromPath }: { from?: string; fromPath?: string }) => {
        if (isAnonymous) {
            mixpanel?.track('go-to-signup', { event: 'click', from: 'create-box', isAnonymous });
            loginWithRedirect({ appState: { returnTo: window.location.origin + AppRoutes.PostSso } });
        } else {
            mixpanel?.track('go-to-create-premium-plus-avatar', { event: 'click', from: 'create-box', isAnonymous });
            navigate(AppRoutes.AvatarsCreatePremiumPlus, { state: { from, fromPath } });
        }
    };

    return { onClick };
};
